<template>
	<div class="">
		<login-after-head-center></login-after-head-center>
		<div id="member" class="container home-container flex">
			<side-nav></side-nav>
			<div class="address-manage base-mes-box">
				<div class="home-allTitle award-title-cg">
					<span>账户信息</span>
				</div>

				<div class="base-mes flex">
					<div class="base-mes-left">
						 <table id="use">
						   <tbody>
<!--						     <tr >-->
<!--						       <td align="right" class="ng-">头像 :</td>-->
<!--						       <td class="pl20 use-img cursorPointe" >-->
<!--						       <img ng-src="" width="80px" height="80px"><span style="cursor: pointer"  class="ng-binding ng-scope">上传</span>-->
<!--						       </td>-->
<!--						     </tr>-->
<!--						     <tr  >-->
<!--						       <td align="right" ><span class="require">*</span>用户编码 :</td>-->
<!--						       <td class="pl20"><input type="text" value="100020309"   placeholder=""  disabled="disabled"></td>-->
<!--						     </tr>-->
						     <tr  >
						       <td align="right" ><span class="require">*</span>账号名称 :</td>
						       <td class="pl20"><input type="text"  placeholder="即为登录名" v-model="userInfo.loginName" disabled="disabled"></td>
						     </tr>
<!--						     <tr  >-->
<!--						       <td align="right" ><span class="require">*</span>客户类型 :</td>-->
<!--						       <td class="pl20"><select  name="userTypeCode"    disabled="disabled">-->
<!--						           <option  value="50" selected  =  "selected">企业客户</option>-->
<!--						         </select>-->
<!--                   </td>-->
<!--						     </tr>-->
						     <tr  >
						       <td align="right" ><span class="require">*</span>联系人 :</td>
						       <td class="pl20"><input type="text" v-model="userInfo.contacts"   @blur="userInfoUpdateFun"></td>
						     </tr>
						     <tr  >
						       <td align="right" ><span class="require">*</span>联系手机号 :</td>
						       <td class="pl20"><input type="text" v-model="userInfo.contactsMobile" @blur="userInfoUpdateFun"></td>
						     </tr>
						     <tr  v-if="distributorInfo.status == 2 && distributorInfo.approvalStatus == 3">
						       <td align="right" ><span class="require">*</span>账号状态 :</td>
						       <td class="pl20"><p style="color: red;">驳回</p></td>
						     </tr>
						     <tr  v-if="distributorInfo.status == 2 && distributorInfo.approvalStatus == 3">
						       <td align="right" ><span class="require">*</span>重新提交资料 :</td>
                     <td class="pl20">
                       <router-link :to="{path:'/regUpdate',query:{id:distributorInfo.id}}" >
                        <p style="color: red;font-size: 12px">点击修改</p>
                       </router-link>
                     </td>
						     </tr>
<!--						     <tr v-if="false" >-->
<!--						       <td align="right" ><span class="require">*</span>公司地址 :</td>-->
<!--						       <td class="pl20"><div class="clearfix mgB10 mgT5">-->
<!--						           <select class="select-address"  name="province" style="padding-left:5px;" id="province" required  disabled="disabled">-->
<!--						             <option value="" >&#45;&#45;省份&#45;&#45;</option>-->
<!--						             <option value="0" label="北京">北京</option>-->
<!--						             <option value="1" label="天津">天津</option>-->
<!--						             <option value="2" label="河北省">河北省</option>-->
<!--						             <option value="3" label="山西省">山西省</option>-->
<!--						             <option value="4" label="内蒙古自治区">内蒙古自治区</option>-->
<!--						             <option value="5" label="辽宁省">辽宁省</option>-->
<!--						             <option value="6" label="吉林省">吉林省</option>-->
<!--						             <option value="7" label="黑龙江省">黑龙江省</option>-->
<!--						             <option value="8" label="上海">上海</option>-->
<!--						             <option value="9" selected="selected" label="江苏省">江苏省</option>-->
<!--						             <option value="10" label="浙江省">浙江省</option>-->
<!--						             <option value="11" label="安徽省">安徽省</option>-->
<!--						             <option value="12" label="福建省">福建省</option>-->
<!--						             <option value="13" label="江西省">江西省</option>-->
<!--						             <option value="14" label="山东省">山东省</option>-->
<!--						             <option value="15" label="河南省">河南省</option>-->
<!--						             <option value="16" label="湖北省">湖北省</option>-->
<!--						             <option value="17" label="湖南省">湖南省</option>-->
<!--						             <option value="18" label="广东省">广东省</option>-->
<!--						             <option value="19" label="广西壮族自治区">广西壮族自治区</option>-->
<!--						             <option value="20" label="海南省">海南省</option>-->
<!--						             <option value="21" label="重庆">重庆</option>-->
<!--						             <option value="22" label="四川省">四川省</option>-->
<!--						             <option value="23" label="贵州省">贵州省</option>-->
<!--						             <option value="24" label="云南省">云南省</option>-->
<!--						             <option value="25" label="西藏自治区">西藏自治区</option>-->
<!--						             <option value="26" label="陕西省">陕西省</option>-->
<!--						             <option value="27" label="甘肃省">甘肃省</option>-->
<!--						             <option value="28" label="青海省">青海省</option>-->
<!--						             <option value="29" label="宁夏回族自治区">宁夏回族自治区</option>-->
<!--						             <option value="30" label="新疆维吾尔自治区">新疆维吾尔自治区</option>-->
<!--						             <option value="31" label="台湾">台湾</option>-->
<!--						             <option value="32" label="香港特别行政区">香港特别行政区</option>-->
<!--						             <option value="33" label="澳门特别行政区">澳门特别行政区</option>-->
<!--						             <option value="34" label="钓鱼岛">钓鱼岛</option>-->
<!--						           </select>-->
<!--						           <select class="select-address"  name="city" id="city" required disabled="disabled">-->
<!--						             <option value="" >&#45;&#45;城市&#45;&#45;</option>-->
<!--						             <option value="0" label="南京市">南京市</option>-->
<!--						             <option value="1" selected="selected" label="无锡市">无锡市</option>-->
<!--						             <option value="2" label="徐州市">徐州市</option>-->
<!--						             <option value="3" label="常州市">常州市</option>-->
<!--						             <option value="4" label="苏州市">苏州市</option>-->
<!--						             <option value="5" label="南通市">南通市</option>-->
<!--						             <option value="6" label="连云港市">连云港市</option>-->
<!--						             <option value="7" label="淮安市">淮安市</option>-->
<!--						             <option value="8" label="盐城市">盐城市</option>-->
<!--						             <option value="9" label="扬州市">扬州市</option>-->
<!--						             <option value="10" label="镇江市">镇江市</option>-->
<!--						             <option value="11" label="泰州市">泰州市</option>-->
<!--						             <option value="12" label="宿迁市">宿迁市</option>-->
<!--						           </select>-->
<!--						           <select class="select-address "  name="region" id="region" required disabled="disabled">-->
<!--						             <option value="" >&#45;&#45;区县&#45;&#45;</option>-->
<!--						             <option value="0" label="崇安区">崇安区</option>-->
<!--						             <option value="1" label="南长区">南长区</option>-->
<!--						             <option value="2" label="北塘区">北塘区</option>-->
<!--						             <option value="3" selected="selected" label="锡山区">锡山区</option>-->
<!--						             <option value="4" label="惠山区">惠山区</option>-->
<!--						             <option value="5" label="滨湖区">滨湖区</option>-->
<!--						             <option value="6" label="江阴市">江阴市</option>-->
<!--						             <option value="7" label="宜兴市">宜兴市</option>-->
<!--						           </select>-->
<!--						         </div></td>-->
<!--						     </tr>-->
						     <tr></tr>
						   </tbody>
						 </table>



						 <div class="fc btn-group">
               <a  class="btn btn_hold" @click="updatePassword">
                 修改密码
               </a>
							 <a href="" class="btn btn_hold">
								 去首页
							 </a>
							 <a class="btn btn_hold" v-if="isShowKefuBtn" @click="goKefu">
								 添加客服
							 </a>
							 <a href="" class="btn btn_hold" v-if="false">
							 								 升级成为企业用户
							 </a>
						 </div>
					</div>
				</div>
			</div>
		</div>
		<i-footer></i-footer>
		<fixed-right></fixed-right>
    <el-dialog width="400px" custom-class="pop-class" :before-close="cancel" :visible.sync="dialog" :title="'修改密码'" >
      <el-form ref="form" :model="form" label-width="100px" >
        <el-form-item label="当前密码" prop="name">
          <div style="width: 172px;">
            <el-input v-model="form.oldPass" type="password" placeholder="请输入当前密码"></el-input>
          </div>
        </el-form-item>
        <el-form-item label="新密码" prop="name">
          <div style="width: 172px;">
            <el-input v-model="form.newPass" type="password" placeholder="请输入新密码"></el-input>
          </div>
        </el-form-item>
        <el-form-item label="确认密码" prop="name">
          <div style="width: 172px;">
            <el-input v-model="form.surePass" type="password" placeholder="请再次输入新密码"></el-input>
          </div>
        </el-form-item>
        <el-form-item>
          <div @click="submitForm()" class="onSubmit">确认修改</div>
        </el-form-item>
        <div style="height: 20px;"></div>
      </el-form>
    </el-dialog>
	</div>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex'
import {
  editAddressData,
  updatePass, userInfoUpdate
} from '@/api/user.js'
import {getUserInfo} from "@/api/login";
import { checkShowKefu, closeKefu } from '@/api/home'
import { getStoredUserInfo, hasUserIdentity, refreshUserInfo, saveUserInfo } from '@/utils/auth'
	export default {

		data() {
			return {
        dialog: false,
        form: {
          oldPass: '',
          newPass: '',
          surePass: ''
        },
        isShowKefuBtn:false,
        distributorInfo:{}
			}
		},computed: {
      ...mapGetters({
        userInfo: 'userInfo', // 用户信息
        cartNum: 'cartNum' // 购物车商品数量
      })
    },
		mounted() {
      const userInfo = hasUserIdentity(this.userInfo) ? this.userInfo : getStoredUserInfo()
      if (hasUserIdentity(userInfo)) {
        this.getUserInfoFun()
        if (userInfo.approvalStatus == 2){
          this.isShowKefuBtn=true
        }
      }
      console.info('用户信息为====》', userInfo)
		},
		methods: {
      goKefu(){
        this.$router.push({
          path: '/kefu'
        })
      },
      getUserInfoFun(){
        getUserInfo({}).then(res=>{
          if (res.status === 200 && res.data) {
            this.distributorInfo = refreshUserInfo(res.data)
            console.log('手动查询的用户', this.distributorInfo)
          }
        })

      },
      userInfoUpdateFun() {
        let updateObj={
          id:this.userInfo.id,
          contacts:this.userInfo.contacts,
          contactsMobile:this.userInfo.contactsMobile
        }
        console.log('修改的参数',updateObj)
        userInfoUpdate(updateObj).then(res=>{
          console.log('修改后的返回',res)
          if (res.data){
            let userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
            userInfo.contacts = updateObj.contacts
            userInfo.contactsMobile = updateObj.contactsMobile
            saveUserInfo(userInfo)
          }
        })
      },
      cancel() {
        this.dialog = false
      },
      updatePassword() {
        this.dialog = true
      },
      submitForm(){
        console.log("调用修改密码====》",this.form)

        if(this.form.newPass!=this.form.surePass){
          this.$message.warning("两次密码输入不一致！")
          return
        }
        updatePass(this.form).then(res => {
          if (res.status === 200) {
            this.dialog = false
          } else {
            this.$message.warning(res.msg)
          }
        })

      }

		},


	}
</script>

<style scoped lang="less">

</style>
